import { Component, Input } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { AppService } from "../app.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Device } from "../device";
import { CryptoService } from "../crypto.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";

@Component({
  selector: "app-view-workspace",
  standalone: false,
  templateUrl: "./view-workspace.component.html",
  styleUrls: ["./view-workspace.component.css"],
})
export class ViewWorkspaceComponent {
  dev: Device | any;
  addKeyForm: FormGroup;
  workspaceId: any;
  apiKey: any;
  status: any;
  workspaceName: any;
  loading = true;
  connectorKeys: any[] = [];
  connectorLLMKeys: any[] = [];
  toggleValue: boolean = true;
  // WSDetails: any = null;
  spdate: any;
  WSCreatedAt: any;
  WSUpdatedAt: any;
  isChecked = true;

  selIndex: any;
  showTick: boolean = false;
  publickeyNav: boolean = true;
  privatekeyNav: boolean = false;
  showAddNewKeyNav: boolean = false;
  sign: any;
  txt: any;
  showTxt: boolean = false;
  copiedStates: { [key: string]: boolean } = {};

  @Input() WSDetails: any;


  uploadKeyControl = new FormControl("", [Validators.required]);
  identifierControl = new FormControl("", [Validators.required]);

  displayedKeysColumns: string[] = [
    "keyType",
    "publickey",
    "status",
  ];

  displayedLLMKeysColumns: string[] = [
    "key",
    "identifier",
    "modelName",
    "status"
  ];


  constructor(
    public appService: AppService,
    public router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private cs: CryptoService,
    private http: HttpClient
  ) {
    this.workspaceId = this.route.snapshot.paramMap.get("id");
    this.workspaceName = this.route.snapshot.paramMap.get("name");
    this.apiKey = this.route.snapshot.paramMap.get("key")

    this.addKeyForm = this.fb.group({
    });

  }

  ngOnInit(): void {
    this.getWorkSpaceDetials();
  }

  async generateNewKey() {
    try {

      const keyPair = await this.appService.getKeyPair();
      const publicKeyPEM = keyPair[0];
      const privateKeyPEM = keyPair[1];

      const submitKeyPayload = {
        apiKey: this.apiKey,
        publicKey: this.appService.convertPEMToBase64(publicKeyPEM),
        routeType: "UI_SESSION"
      };

      let submitKeyResp = await this.appService.postRequest(
        submitKeyPayload,
        "auth/submit-key"
      );

      this.appService.addSuccessMessage(
        "New key generated successfully!"
      );
      this.getWorkSpaceDetials();

      if (submitKeyResp?.status !== "Success") {
        this.appService.addErrorMessage(
          submitKeyResp?.message || "Key submission failed"
        );
        return;
      }

      setTimeout(() => {
        this.downloadFile(privateKeyPEM, this.workspaceName);
        this.appService.addSuccessMessage(
          "Privatekey downloaded successfully!"
        );
      }, 3000);
    } catch (error: any) {
      console.error("Error in submit:", error);
      this.appService.addErrorMessage(
        "Failed to create workspace: " + (error.message || "Unknown error")
      );
    }
  }

  // Download private key
  downloadFile(pkeyStr: string, wpsName: string) {
    var a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(
      new Blob([pkeyStr], { type: "text/plain" })
    );
    a.download = wpsName + "_privatekey.pem";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }


  async onChangeKeyStatus(element: any): Promise<void> {
    // element.expired = element.expired === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
    // const newValue = event.checked;
    element.expired = element.expired === true || element.expired === 'true' ? false : true;

    try {
      const payload = {
        keyId: element.id,
        expired: element.expired
      };

      const signatureData = await this.appService.wssign(
        payload,
        this.workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
        payload,
        "auth/change-key-status",
        this.apiKey,
        signature
      );
      if (response && response.status == "Success") {
        this.appService.addSuccessMessage("Key status updated successfully.");
        this.loadConnectorKeys();
        // this.getWorkSpaceDetials();
      } else {
        throw new Error(response?.message);
      }
    } catch (error: any) {
      console.error("Error in key:", error);
    }
  }

  async onChangeLLMKeyStatus(element: any): Promise<void> {
    // const checked = event.checked; // boo,lean
    // element.status = checked ? 'ACTIVE' : 'INACTIVE';
    element.status = element.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';

    try {
      const payload = {
        keyId: element.id,
        status: element.status
      };

      const signatureData = await this.appService.wssign(
        payload,
        this.workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
        payload,
        "user/change-llmkey-status",
        this.apiKey,
        signature
      );
      if (response && response.status == "Success") {
        this.appService.addSuccessMessage("Key status updated successfully.");
        this.getWorkSpaceDetials();
        this.loadConnectorLLMKeys();
      } else {
        throw new Error(response?.message);
      }
    } catch (error: any) {
      console.error("Error in key:", error);
    }


  }


  addNewKey() {
    this.showAddNewKeyNav = !this.showAddNewKeyNav;
  }

  async submitLLMKey() {

    try {
      const uploadedKey = this.uploadKeyControl.value;
      const identifierVal = this.identifierControl.value;

      if (!uploadedKey?.trim()) {
        return;
      }

      const payload = {
        apiKey: this.apiKey,
        key: uploadedKey,
        identifier: identifierVal,
        model: "gpt-4",
      };

      const signatureData = await this.appService.wssign(
        payload,
        this.workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
        payload,
        "user/register-llm",
        this.apiKey,
        signature
      );
      this.appService.addSuccessMessage("key submitted successfully.");
      if (response && response.status == "Success") {
        this.getWorkSpaceDetials();
        this.uploadKeyControl.reset();
        this.identifierControl.reset();
        this.showAddNewKeyNav = false;
      } else {
        this.uploadKeyControl.reset();
        this.identifierControl.reset();
        throw new Error(response?.message);
      }
    } catch (error: any) {
      // this.appService.addErrorMessage("API key is invalid or expired");
      console.error("Error in key:", error);

    }
  }

  maskApiKey(apiKey: string): string {
    if (!apiKey || apiKey.length <= 10) {
      return apiKey;
    }
    const start = apiKey.substring(0, 3);
    const end = apiKey.substring(apiKey.length - 4);
    return `${start}${"*".repeat(6)}${end}`;
  }

  // New method to get copy tooltip text
  getCopyTooltip(apiKey: string): string {
    return this.copiedStates[apiKey] ? "Copied" : "Copy";
  }

  async copyMessage(message: string) {
    try {
      await navigator.clipboard.writeText(message);

      this.copiedStates[message] = true;

      setTimeout(() => {
        this.copiedStates[message] = false;
      }, 2000);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  }


  async getWorkSpaceDetials() {

    try {
      const activationPayload: any = {
        workspaceId: this.workspaceId,
        apikey: this.apiKey,
        routeType: "UI_SESSION"
      };

      const signatureData = await this.appService.wssign(
        activationPayload,
        this.workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
        activationPayload,
        "auth/view-workspace",
        this.apiKey,
        signature
      );
      this.loading = false;
      if (response && response?.status === "Success") {
        this.WSDetails = response?.data;
        this.loadConnectorKeys();
        this.loadConnectorLLMKeys();

        this.spdate = response?.data?.usageSummary?.startPeriod * 1000;
        this.WSCreatedAt = response?.data?.workspace?.createdAt * 1000;
        this.WSUpdatedAt = response?.data?.workspace?.updatedAt * 1000;
      } else {
        throw new Error(response?.message);
      }
    } catch (error: any) {
      console.error("Error in getAudits:", error);
    }
  }


  loadConnectorKeys(): void {
    this.connectorKeys = this.WSDetails?.connectorKeys || [];
  }

  loadConnectorLLMKeys(): void {
    this.connectorLLMKeys = [...this.WSDetails?.connectorLLMKeys || []];
    // this.connectorLLMKeys = this.WSDetails?.connectorLLMKeys || [];
    console.log('connectorLLMKeys:', this.connectorLLMKeys); // Check if it has data

  }

  cancel() {
    this.router.navigate(["/workspace"]);
  }


}
